<template>
    <div>
      <document-type-list></document-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  